<div class="wrapper-box">
  <div class="container">
    <div class="row">
      <div class="col-md-6">
        <div class="contact">
          <h3>Contact information</h3>
          <div class="icons1">
             &nbsp; &nbsp; &nbsp; &nbsp;
          <a href="https://www.facebook.com/Pikoro-106660204828663" target="_Blank">
            <fa-icon  [icon]="faPhone" style="font-size: x-large;color: #5a54ff;" ></fa-icon>
          </a>
          <h4>+216 123 123 123</h4><br/>
          &nbsp; &nbsp; &nbsp; &nbsp;
          <a href="https://www.facebook.com/Pikoro-106660204828663" target="_Blank">
            <fa-icon [icon]="faEnvolope" style="font-size: x-large; color: #5a54ff;" ></fa-icon>
          </a>
          <h4>Pikoro@gmail.com</h4></div>
          <h3>Follow us</h3>
          <div class="icons">
          <a target="_Blank" href="https://www.facebook.com/Pikoro-106660204828663"><fa-icon [icon]="faFacebook" ></fa-icon></a>
          <a target="_Blank" href="https://www.instagram.com/pikoro_company/" style="color: blueviolet"><fa-icon [icon]="faInstagram" ></fa-icon></a>
          <a target="_Blank" href="https://www.youtube.com/" style="color: red;"><fa-icon [icon]="faYoutube" ></fa-icon></a>
          <a target="_Blank" href="https://www.linkedin.com/company/pikoro/"><fa-icon [icon]="faLinkedin" ></fa-icon></a>
        </div>
          <img src="../../assets/images/contact.png" alt="contact" />
        </div>
      </div>
      <div class="col-md-6">
        <div class="contact-form">
          <form #contact="ngForm">
            <h2 class="text-center mb-5">Get in touch</h2>
            <p>Feel free to connect with us</p>
            <div class="form-group">
              <label>Email</label>
              <input id="email" type="email" class="form-control" name="email" placeholder="Your Email Here..." required #e="ngModel" ngModel pattern="[a-zA-Z0-9-.]+@[a-zA-Z0-9]+.[a-zA-Z0-9]{2,4}" />
                <small id="emailHelp" class="form-text text-muted">We will never share your email with anyone else.</small>
            </div>
            <div class="alert alert-danger" *ngIf="e.invalid && e.touched">
              <div *ngIf="e.errors.required"> Champ Obligatoire ! </div>
              <div *ngIf="e.errors.pattern"> Email Invalid </div>
            </div>
            <div class="form-group">
              <label>Subject</label>
              <select id="sujet" class="form-control" aria-label="Default select example" name="sujet" ngModel>
                <option value="Question" class="form-control" id="option">Question</option>
                <option value="Réclamation" class="form-control" id="option">Claim</option>
                <option value="Réclamation" class="form-control" id="option">Response</option>
                <option value="Réclamation" class="form-control" id="option">Explanation</option>
                <option value="Autre" class="form-control" id="option">Other</option>
              </select>
            </div>
            <div class="form-group">
              <label>Message</label>
              <textarea id="message" class="form-control" name="message" required #m="ngModel" ngModel ></textarea>
            </div>
            <div class="alert alert-danger" *ngIf="m.invalid && m.touched">
              <div *ngIf="e.errors.required"> Your Message Here... ! </div>
            </div>
            <button [disabled]="contact.invalid" class="btn" type="button" (click)="sendMail(contact)">Send</button>
            <br>
            <br>
            <div id="status" [hidden]="showmessage" style="margin-left: 25%;" >{{message}}</div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
